export default "__VITE_ASSET__Col0CpdE__"